import { useMemo, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { useExperience } from '@/store/experience';

const vertex = /* glsl */ `
varying vec3 vDir;
void main(){
  vDir = normalize(position);
  vec4 mv = modelViewMatrix * vec4(position, 1.0);
  gl_Position = projectionMatrix * mv;
}`;

const fragment = /* glsl */ `
uniform vec3 uZenith; uniform vec3 uHorizon; uniform vec3 uBelow; uniform vec3 uSunDir; uniform float uWhite;
varying vec3 vDir;
void main(){
  vec3 dir = normalize(vDir);
  float h = dir.y;
  vec3 col = mix(uHorizon, uZenith, 1.0 - exp(-max(h, 0.0) * 3.2));
  col = mix(col, uBelow, 1.0 - smoothstep(-0.45, 0.0, h));
  col += vec3(0.75, 0.85, 1.0) * exp(-abs(h) * 10.0) * 0.16;
  float sd = max(dot(dir, uSunDir), 0.0);
  col += vec3(1.0, 0.93, 0.8) * (pow(sd, 400.0) * 0.9 + pow(sd, 40.0) * 0.35 + pow(sd, 4.0) * 0.08);
  col = mix(col, vec3(1.0), uWhite);
  gl_FragColor = vec4(col, 1.0);
}`;

export function SkyDome() {
  const ref = useRef();
  const frame = useExperience((s) => s.frame);
  const uniforms = useMemo(() => ({
    uZenith: { value: new THREE.Color('#061a3d') }, uHorizon: { value: new THREE.Color('#3f86cf') },
    uBelow: { value: new THREE.Color('#79a9dc') }, uSunDir: { value: new THREE.Vector3(0.55, 0.42, -0.72).normalize() }, uWhite: { value: 0 },
  }), []);
  useFrame(({ camera }) => {
    ref.current.position.copy(camera.position);
    ref.current.material.uniforms.uWhite.value = frame.fog;
  });
  return (
    <mesh ref={ref} renderOrder={-10} frustumCulled={false}>
      <sphereGeometry args={[500, 64, 40]} />
      <shaderMaterial vertexShader={vertex} fragmentShader={fragment} uniforms={uniforms} side={THREE.BackSide} depthWrite={false} depthTest={false} />
    </mesh>
  );
}
